<template>
    <div>
        <div class="fixed inset-0 z-modal-container bg-opacity-50 w-full max-h-screen h-screen flex items-start md:items-center justify-center p-2 sm:p-4">
            <div class="app-modal bg-white flex flex-col rounded-lg shadow-2xl max-h-full overflow-hidden" :class="[{'full-height': fullHeight}, modalSize, modalClass]">
                <div class="header" :class="headerClass">
                    <div class="flex-1">
                        <slot name="header"></slot>
                    </div>
                    <div class="">
                        <div :class="closeIconClass ? closeIconClass : 'text-gray-500 hover:text-gray-700'" class="cursor-pointer" @click="$emit('close')">
                            <svg viewBox="0 0 20 20" fill="currentColor" class="x w-4 h-4"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        </div>
                    </div>
                </div>
                <div class="body" :class="bodyClass">
                    <slot name="body"></slot>
                </div>
                <div class="footer" v-if="$slots['footer']" :class="footerClass">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Modal',
        props: {
            fullHeight: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
                default: 'md',
            },
            modalClass: {
                type: String,
                default: '',
            },
            headerClass: {
                type: String,
                default: '',
            },
            bodyClass: {
                type: String,
                default: '',
            },
            footerClass: {
                type: String,
                default: '',
            },
            closeIconClass: {
                type: String,
                default: '',
            }
        },
        // mounted () {
        //     document.body.appendChild(this.$el);
        // },
        computed: {
            modalSize: function () {
                return 'size-' + this.size
            }
        }
    }
</script>

<style lang="scss" scoped>

    .bg-opacity-50 {
        background: rgba(0, 0, 0, 0.3);
    }

    .app-modal {        
        &.size-xs {width: 380px;}
        &.size-sm {width: 576px;}
        &.size-md {width: 768px;}
        &.size-lg {width: 992px;}
        &.size-xl {width: 1200px;}
        &.size-2xl {width: 1440px;}
        &.size-fluid {width: auto;}
        &.size-full {width: 90%;}
        
        .header {
            @apply bg-white border-0 border-solid border-gray-300 border-b p-4 text-gray-700 flex items-center text-xl;
        }
        
        .body {
            @apply flex-1 overflow-auto;
        }
        
        .footer {
            @apply bg-white border-0 border-solid border-gray-300 border-t p-4;
        }
        
        &.full-height {
            height: 100% !important;
            
            .body {
                height: 100% !important;
            }
        }
    }

</style>